import { render, staticRenderFns } from "./saaSDataListCopy.vue?vue&type=template&id=de386f3c&scoped=true"
import script from "./saaSDataListCopy.vue?vue&type=script&lang=js"
export * from "./saaSDataListCopy.vue?vue&type=script&lang=js"
import style0 from "./saaSDataListCopy.vue?vue&type=style&index=0&id=de386f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de386f3c",
  null
  
)

export default component.exports